import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { del, put } from "../../utils/api";
import { useUser } from "../../context/AuthContext";

const DeleteAlertDialog = ({
  deleteDialog,
  setDeleteDialog,
  url,
  id,
  method = "put",
  setsnackOpen,
  fetchData,
  fetchCardData,
}) => {
  const { user } = useUser();
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleDeleteAggree = async () => {
    if (user?.endUser && !reason.trim()) {
      setError("Reason is mandatory");
      return;
    }

    try {
      const res =
        method === "put"
          ? await put(`${url}?Id=${id}`, { reason })
          : await del(`${url}?Id=${id}`, { data: { reason } });

      setDeleteDialog(false);
      setsnackOpen({
        open: true,
        message: res.data.message,
        severity: "success",
      });
      await fetchData();
      if (typeof fetchCardData === "function") {
        await fetchCardData();
      }
      setReason("");
      setError("");
    } catch (err) {
      setsnackOpen({
        open: true,
        message:
          err.response?.data?.message ||
          err?.data?.response?.message ||
          "Network Error",
        severity: "error",
      });
    }
  };

  const handleClose = () => {
    setDeleteDialog(false);
    setReason("");
    setError("");
  };

  return (
    <Dialog
      open={deleteDialog}
      onClose={handleClose}
      // maxWidth={user?.endUser ? "sm" : "xs"}
      PaperProps={{
        sx: user?.endUser ? { width: "500px", maxWidth: "100%" } : undefined,
      }}
    >
      <DialogTitle>
        {" "}
        {user?.endUser ? "Send Delete Request" : "Confirm Delete"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {user?.endUser
            ? "Are you sure you want to send a delete request for this entry? Please provide a valid reason."
            : "Do you really want to delete this entry?"}
        </DialogContentText>
        {user?.endUser && (
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Remark Reason"
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
              if (error) setError("");
            }}
            margin="dense"
            error={!!error}
            helperText={error}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        {user?.endUser ? (
          <Button onClick={handleDeleteAggree} color="secondary">
            Send
          </Button>
        ) : (
          <Button onClick={handleDeleteAggree} color="secondary">
            Confirm
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAlertDialog;
